import axios from "axios";
import { BASE_URL_RELIANCE } from "./utilityService";

export class PublicApiService {
  #ax;

  constructor(accessToken = "") {
    this.#ax = axios.create({
      baseURL: BASE_URL_RELIANCE,
      headers: {
        "Content-Type": "application/json",

        ...(accessToken && {
          Authorization: `Bearer ${accessToken}`,
        }),
      },
    });
  }

  async post(url, data) {
    const response = await this.#ax.post(url, data);
    return response.data;
  }

  async put(url, data) {
    const response = await this.#ax.put(url, data);
    return response.data;
  }

  async patch(url, data) {
    const response = await this.#ax.patch(url, data);
    return response.data;
  }

  async get(url, data) {
    const response = await this.#ax.get(`${url}`);
    return response.data;
  }
}

export default new PublicApiService();
